import React from 'react'
import {
    Container, Row,
    Col, Label, Input, Button,
} from 'reactstrap'
import {
    login, createAccount,
    sendForgotPasswordEmail,
    updatePassword,
} from '../model/request/login'
import {AlertModalModel} from './modal/AlertModalController.js'
import {Account} from '../model/Account'

const Page = {
    "Login": 1,
    "CreateAccount": 2,
    "ForgotPassword": 3,
    "ChangePassword": 4,
}
Object.freeze(Page)

class LoginViewController extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            'account': Object.assign(new Account(), {
                'confirmpassword': '',
            }),
        }
    }

    clickedEnter(page) {
        switch (page) {
            case Page.Login:
                this.login()
                break
            case Page.CreateAccount:
                this.checkAndCreateAccount()
                break
            case Page.ForgotPassword:
                this.sendForgotPassword()
                break
            case Page.ChangePassword:
                this.changePassword()
                break
            default:
                break
        }
    }

    /**
     * Reads the `redirect` query param (set when a stale session bounces
     * the user to login mid-use, see the 401 forceLogin interceptor in
     * model/request/url.js) and validates it's a same-site relative path,
     * not an absolute/protocol-relative URL, before trusting it - otherwise
     * a crafted link could redirect a user externally right after login.
     * @return {string}
     */
    getSafeRedirectTarget() {
        const params = new URLSearchParams(window.location.search)
        const redirect = params.get('redirect')
        if (redirect && redirect.startsWith('/') &&
            !redirect.startsWith('//') && !redirect.startsWith('/\\')) {
            return redirect
        }
        return '/jobs'
    }

    login() {
        this.props.turnOnLoader()
        login(this.state.account.email, this.state.account.password)
        .then(
            (result) => {
                const account = Account.from(result.data.account)
                account.saveToLocalStorage()
                window.location.href = this.getSafeRedirectTarget()
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    checkAndCreateAccount() {
        if (!this.validateEmail(this.state.account.email)) {
            this.props.showError('Not a valid email.')
            return
        }

        if (this.state.account.password !== this.state.account.confirmpassword) {
            this.props.showError('Your passwords do not match.')
            return
        }

        const account = this.state.account
        account.settings.asante_contact_info.first_name = account.first_name
        account.settings.asante_contact_info.last_name = account.last_name
        account.settings.asante_contact_info.email = account.email

        account.settings.contact_info.first_name = account.first_name
        account.settings.contact_info.last_name = account.last_name
        account.settings.contact_info.company = account.company
        account.settings.contact_info.email = account.email

        account.settings.shipping_info.first_name = account.first_name
        account.settings.shipping_info.last_name = account.last_name
        account.settings.shipping_info.company = account.company
        account.settings.shipping_info.email = account.email

        this.props.turnOnLoader()
        createAccount(this.state.account)
        .then(
            (result) => {
                window.location.href = '/jobs'
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    sendForgotPassword() {

        this.props.turnOnLoader()
        sendForgotPasswordEmail(this.state.account.email)
        .then(
            (result) => {
                this.props.showAlertModal((new AlertModalModel())
                    .setTitle('Email Sent')
                    .setMessage('We sent an email to ' + this.state.account.email +
                        '. If you didnt get an email after 5 minutes then check' +
                        ' spam and try again.')
                    .addOkButton(() => {
                        this.props.closeModal()
                    }))

                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    changePassword() {
        if (this.state.account.password !== this.state.account.confirmpassword) {
            this.props.showError('Your passwords do not match.')
            return
        }

        this.props.turnOnLoader()
        updatePassword(this.props.id, this.state.account.password)
        .then(
            (result) => {
                this.props.showAlertModal(
                    (new AlertModalModel())
                        .setTitle('Success')
                        .setMessage('Your password has been updated.')
                        .addOkButton(() => {
                            window.location.href = '/account/login'
                        }
                    )
                )
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    renderRow(label, varName, inputType, onClickEnter=null) {
        return <>
            <Row style={{'marginTop': '8px'}}>
                <Col>
                    <Label>{label}</Label>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input type={inputType}
                        onKeyDown={(e) => {
                            if (onClickEnter && !e.shiftKey && e.key === 'Enter') {
                                onClickEnter()
                            }
                        }}
                        value={this.state.account[varName]} onChange={(e) => {
                        const newAccount = this.state.account
                        newAccount[varName] = e.target.value
                        this.setState({
                            'account': newAccount,
                        })
                    }}/>
                </Col>
            </Row>
        </>
    }


    // MARK: render

    renderLogin(page) {
        const titles = ['', 'Login', 'Create Account', 'Forgot Password?', 'Update Password']
        return <>
            <Row>
                <Label style={{
                    'fontSize': '18px',
                    'fontWeight': '400',
                }}>{titles[page]}</Label>
            </Row>
                { page !== 2 ? <></> :
                    <>
                    {this.renderRow('First Name', 'first_name', 'text')}
                    {this.renderRow('Last Name', 'last_name', 'text')}
                    {this.renderRow('Company', 'company', 'text')}
                    </>
                }
                { page === 4 ? <></> : this.renderRow('Email', 'email', 'email')}
                { page === 3 ? <></> :
                    this.renderRow('Password', 'password', 'password', page === 1 ? () => {
                        this.clickedEnter(page)
                    } : null)
                }
                { !(page === 2 || page === 4) ? <></> :
                    this.renderRow('Confirm Password', 'confirmpassword', 'password', () => {
                        this.clickedEnter(page)
                    })
                }
            <Row style={{
                'marginTop': '8px',
                'textAlign': 'right',
            }}><Col>
                    <Button style={{
                        'position': 'right',
                    }} onClick={(e) => {
                        this.clickedEnter(page)
                    }}>Submit</Button>
                </Col>
            </Row>
            <Row style={{
                'textAlign': 'center',
            }}>
                {page === 1 ? <></> :
                    <Col>
                        <a href='/account/login'>Login</a>
                    </Col>
                }
                {page === 2 ? <></> :
                    <Col>
                        <a href='/account/create'>Create Account</a>
                    </Col>
                }
                {page === 3 ? <></> :
                    <Col>
                        <a href='/account/forgotpassword'>Forgot Password</a>
                    </Col>
                }
            </Row>
        </>
    }

    render() {
        return (
            <Container className="center" style={{
                'maxWidth': '320px',
                'border': '#ccc',
                'borderStyle': 'groove',
                'borderRadius': '8px',
                'paddingTop': '8px',
                'paddingLeft': '20px',
                'paddingBottom': '8px',
                'backgroundColor': 'antiquewhite',
                'zIndex': '999',
            }}>
                {this.renderLogin(this.props.page)}
            </Container>
        )
    }
}

export default LoginViewController

